<link rel="stylesheet" href="where-you-can-fly.component.scss" />
<div class="grid header">
    <div class="main-section">
        <h1 [innerHTML]="'dtmMainPageLib.subpage.whereYouCanFly.title' | transloco"></h1>
        <p class="message">
            {{ "dtmMainPageLib.subpage.whereYouCanFly.description" | transloco }}
        </p>
        <div class="patrons">
            <p>
                {{ "dtmMainPageLib.subpage.whereYouCanFly.patronsText" | transloco }}
            </p>
            <ul
                class="logos"
                *ngIf="'dtmMainPageLib.subpage.whereYouCanFly.patrons.websiteLinkAltTextSuffix' | transloco as websiteLinkAltTextSuffix"
            >
                <li>
                    <a [href]="PATRON_LINKS.warsaw.url" target="_blank" rel="noreferrer noopener"
                        ><img
                            ngSrc="/assets/images/where-you-can-fly/logo-warszawa.svg"
                            width="59"
                            height="90"
                            [alt]="('dtmMainPageLib.subpage.whereYouCanFly.patrons.warsaw' | transloco) + websiteLinkAltTextSuffix"
                    /></a>
                </li>
                <li>
                    <a [href]="PATRON_LINKS.warszawaChroni.url" target="_blank" rel="noreferrer noopener"
                        ><img
                            ngSrc="/assets/images/where-you-can-fly/logo-warszawa-chroni.svg"
                            width="116"
                            height="84"
                            [alt]="('dtmMainPageLib.subpage.whereYouCanFly.patrons.warszawaChroni' | transloco) + websiteLinkAltTextSuffix"
                    /></a>
                </li>
                <li>
                    <a [href]="PATRON_LINKS.warsawPolice.url" target="_blank" rel="noreferrer noopener"
                        ><img
                            ngSrc="/assets/images/where-you-can-fly/logo-warszawa-policja.png?onesize"
                            width="93"
                            height="124"
                            [alt]="('dtmMainPageLib.subpage.whereYouCanFly.patrons.warsawPolice' | transloco) + websiteLinkAltTextSuffix"
                    /></a>
                </li>
                <li>
                    <a [href]="PATRON_LINKS.sop.url" target="_blank" rel="noreferrer noopener"
                        ><img
                            ngSrc="/assets/images/where-you-can-fly/logo-sop.png?onesize"
                            width="75"
                            height="52"
                            [alt]="('dtmMainPageLib.subpage.whereYouCanFly.patrons.sop' | transloco) + websiteLinkAltTextSuffix"
                    /></a>
                </li>
                <li>
                    <a [href]="PATRON_LINKS.ulc.url" target="_blank" rel="noreferrer noopener"
                        ><img
                            ngSrc="/assets/images/where-you-can-fly/logo-ulc.png?onesize"
                            width="123"
                            height="56"
                            [alt]="('dtmMainPageLib.subpage.whereYouCanFly.patrons.ulc' | transloco) + websiteLinkAltTextSuffix"
                    /></a>
                </li>
                <li>
                    <a [href]="PATRON_LINKS.pansa.url" target="_blank" rel="noreferrer noopener"
                        ><img
                            ngSrc="/assets/images/where-you-can-fly/logo-pansa.svg"
                            width="132"
                            height="68"
                            [alt]="('dtmMainPageLib.subpage.whereYouCanFly.patrons.pansa' | transloco) + websiteLinkAltTextSuffix"
                    /></a>
                </li>
            </ul>
        </div>
    </div>
    <img class="header-image" ngSrc="/assets/images/where-you-can-fly/map.svg" width="376" height="357" alt="" />
</div>
<div class="sections-container">
    <div class="grid tiles">
        <div class="tile">
            <h2>
                {{ "dtmMainPageLib.subpage.whereYouCanFly.tiles.whyImportantInfo.title" | transloco }}
                <img ngSrc="/assets/images/where-you-can-fly/triangle.svg" width="64" height="64" alt="" />
            </h2>
            <p>
                {{ "dtmMainPageLib.subpage.whereYouCanFly.tiles.whyImportantInfo.description" | transloco }}
                <a href="https://ulc.gov.pl/drony/informacje-ogolne/akty-prawne" rel="noopener noreferrer" target="_blank">
                    {{ "dtmMainPageLib.subpage.whereYouCanFly.tiles.whyImportantInfo.regulationsLinkLabel" | transloco }}
                </a>
            </p>
            <div class="list">
                <p>
                    {{ "dtmMainPageLib.subpage.whereYouCanFly.tiles.whyImportantInfo.beforeFLightTitle" | transloco }}
                </p>
                <ul>
                    <li>
                        {{ "dtmMainPageLib.subpage.whereYouCanFly.tiles.whyImportantInfo.firstPointLabel" | transloco }}
                    </li>
                    <li>
                        {{ "dtmMainPageLib.subpage.whereYouCanFly.tiles.whyImportantInfo.secondPointLabel" | transloco }}
                    </li>
                </ul>
                <p class="summary">
                    {{ "dtmMainPageLib.subpage.whereYouCanFly.tiles.whyImportantInfo.summaryLabel" | transloco }}
                </p>
            </div>
        </div>
        <div class="tile no-fly-zones">
            <h2>
                {{ "dtmMainPageLib.subpage.whereYouCanFly.tiles.warsawNoFlyInfo.title" | transloco }}
                <img ngSrc="/assets/images/where-you-can-fly/question-mark-blue.svg" width="64" height="64" alt="" />
            </h2>
            <p>
                {{ "dtmMainPageLib.subpage.whereYouCanFly.tiles.warsawNoFlyInfo.description" | transloco }}
            </p>
            <div class="list">
                <p>
                    {{ "dtmMainPageLib.subpage.whereYouCanFly.tiles.warsawNoFlyInfo.selectedNoFlyZonesTitle" | transloco }}
                </p>
                <ul>
                    <li>
                        {{ "dtmMainPageLib.subpage.whereYouCanFly.tiles.warsawNoFlyInfo.firstZoneLabel" | transloco }}
                    </li>
                    <li>
                        {{ "dtmMainPageLib.subpage.whereYouCanFly.tiles.warsawNoFlyInfo.secondZoneLabel" | transloco }}
                    </li>
                    <li>
                        {{ "dtmMainPageLib.subpage.whereYouCanFly.tiles.warsawNoFlyInfo.thirdZoneLabel" | transloco }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="grid apps">
        <img class="apps-image" ngSrc="/assets/images/where-you-can-fly/application.png" width="558" height="470" alt="" />
        <div class="apps-links">
            <h2>
                {{ "dtmMainPageLib.subpage.whereYouCanFly.downloadApp.title" | transloco }}
            </h2>
            <p>
                {{ "dtmMainPageLib.subpage.whereYouCanFly.downloadApp.description" | transloco }}
            </p>
            <div class="zones-info">
                <div>
                    <dtm-ui-icon name="checkbox-circle-fill" class="allowed" />
                    <span>
                        {{ "dtmMainPageLib.subpage.whereYouCanFly.downloadApp.allowedZonesLabel" | transloco }}
                    </span>
                </div>
                <div>
                    <dtm-ui-icon name="error-warning-fill" class="restricted" />
                    <span>
                        {{ "dtmMainPageLib.subpage.whereYouCanFly.downloadApp.restrictedZonesLabel" | transloco }}
                    </span>
                </div>
                <div>
                    <dtm-ui-icon name="sign-prohibition" class="prohibited" />
                    <span>
                        {{ "dtmMainPageLib.subpage.whereYouCanFly.downloadApp.noFlyZonesLabel" | transloco }}
                    </span>
                </div>
            </div>
            <ul>
                <li>
                    <a [href]="DRONE_TOWER_PLAY_STORE_LINK" rel="noopener noreferrer" target="_blank">
                        <img
                            ngSrc="/assets/images/where-you-can-fly/google-play.png?v=1"
                            width="170"
                            height="157"
                            [alt]="'dtmMainPageLib.subpage.whereYouCanFly.downloadApp.googlePlayLinkAltText' | transloco"
                        />
                    </a>
                </li>
                <li>
                    <a [href]="DRONE_TOWER_APP_STORE_LINK" rel="noopener noreferrer" target="_blank">
                        <img
                            ngSrc="/assets/images/where-you-can-fly/app-store.png?v=1"
                            width="170"
                            height="157"
                            [alt]="'dtmMainPageLib.subpage.whereYouCanFly.downloadApp.appStoreLinkAltText' | transloco"
                    /></a>
                </li>
            </ul>
        </div>
    </div>
    <div class="grid">
        <dtm-main-page-lib-where-you-can-fly-faq />
    </div>
    <dtm-main-page-lib-info
        [headerText]="'dtmMainPageLib.subpage.whereYouCanFly.infoBrochure.title' | transloco"
        [linkText]="'dtmMainPageLib.subpage.whereYouCanFly.infoBrochure.linkLabel' | transloco"
        isDownload
        [link]="INFO_BROCHURE_URL"
    />
    <dtm-main-page-lib-campaign-media />
    <dtm-main-page-lib-campaign-patrons />
</div>
